import React, {
	DetailedHTMLProps,
	HTMLAttributes,
	useEffect,
	useState,
} from 'react';

const Button = (
	props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> &
		IButtonProps
) => {
	const [btnClicked, setBtnClicked] = useState(false);

	useEffect(() => {
		console.log(props?.clicked);
		setBtnClicked(false);
	}, [props?.clicked]);

	useEffect(() => {
		if (props.loading == undefined || props.loading == null) return;
		setBtnClicked(props.loading);
	}, [props?.loading]);

	return (
		<button
			type='button'
			className={`button ${props?.className} ${
				props?.diactivated ? 'deactiveBtn' : ''
			} ${btnClicked && !props?.diactivated ? 'button--loading' : ''}`}
			onClick={() => {
				if (!props?.diactivated) {
					props?.onClickEvent?.();
					if (props?.clicked) setBtnClicked(true);
				}
			}}
		>
			{(!btnClicked || !props?.active) && (
				<span className='button__text'>{props?.labal}</span>
			)}
		</button>
	);
};

export default Button;

type IButtonProps = {
	labal: string;
	customStyle?: string;
	diactivated?: boolean;
	onClickEvent?: () => void;
	clicked?: boolean;
	active?: boolean;
	loading?: boolean;
};
